import { getConfig } from '@b2ag/micro-front-tools'
import { AlgoliaRecommendService, AlgoliaSearchService } from './'
import algoliasearch from 'algoliasearch/lite'
import recommend from '@algolia/recommend'
import { useAuthService } from '@b2ag/auth'
import { useLogger } from '@b2ag/utils/src/useLogger'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import { createProductSdk } from '@b2ag/utils/src/esmParser'
import { i18n } from '@b2ag/locale'
import type { InvivoLocale } from '@invivodf/locale'
import { getConfigProduct } from './config'
import { CustomFilterService } from './services/custom-filter.service'

const searchAppId = getConfig('ALGOLIA_APP_ID')
const searchApiKey = getConfig('ALGOLIA_API_KEY')
const accessTokenSource = () => useAuthService().getAccessToken()
const logger = useLogger()
const callerId = buildCallerId()

export const productSdk = createProductSdk(`${getConfigProduct().productApiHost}`, {
  callerId,
  accessTokenSource,
  logger,
  localeSource: () => i18n.locale as InvivoLocale,
})

export const algoliaClient = algoliasearch(searchAppId, searchApiKey)
export const searchService = new AlgoliaSearchService(algoliaClient)
export const algoliaRecommendClient = recommend(searchAppId, searchApiKey)
export const recommendService = new AlgoliaRecommendService(algoliaRecommendClient)
export const customFilterService = new CustomFilterService(productSdk)
